module.exports = __webpack_public_path__ + "images/favicon.staging.ico";


//////////////////
// WEBPACK FOOTER
// ./images/favicon.staging.ico
// module id = 1115
// module chunks = 1